import { render, staticRenderFns } from "./blue-pop.vue?vue&type=template&id=9f56c7d8&scoped=true"
import script from "./blue-pop.vue?vue&type=script&lang=ts"
export * from "./blue-pop.vue?vue&type=script&lang=ts"
import style0 from "./blue-pop.vue?vue&type=style&index=0&id=9f56c7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f56c7d8",
  null
  
)

export default component.exports